export const ASSIGNMENT_CHANGE_CHANNEL = 'enpal-assignment-change';

export interface AssignmentChangedMessage {
  type: 'assignment-changed';
  previousCaseId: string;
}

export const isAssignmentChangedMessage = (value: unknown): value is AssignmentChangedMessage => {
  if (!value || typeof value !== 'object') return false;

  const message = value as Partial<AssignmentChangedMessage>;
  return message.type === 'assignment-changed' && typeof message.previousCaseId === 'string' && message.previousCaseId.length > 0;
};
